// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Search_wrapper__2BTnB","search":"Search_search__1sDmQ","iconWrapper":"Search_iconWrapper__ZsA8d"};